<form class="form-vertical" id="editprivgroupform" data-hook="editprivcatgroupform">
    <div class="row">
        <div class="form-group col-xs-12 col-md-3">
            <label for="grpshortcut">Kürzel</label>
            <input class="form-control" type="text" required ng-model="vm.privcatgroup.shortcut" id="grpshortcut">
        </div>
        <div class="form-group col-xs-12 col-md-9">
            <label for="grpname">Bezeichnung der Leistungsgruppe</label>
            <input class="form-control" type="text" required ng-model="vm.privcatgroup.name" id="grpname">
        </div>
    </div>

    <div class="row">
        <div class="form-group col-xs-12 col-md-12">
            <label for="grpname">Privatleistung hinzufügen</label>
            <div class="input-group">
                <input type="text" class="form-control" tabindex="{{vm.tabi}}"
                       ng-class="{'dirtyfield': vm.asyncSelected.length > 0}"
                       autofocus
                       placeholder="Kürzel oder Bezeichnung der Privatleistung"
                       ng-model="vm.asyncSelected"
                       typeahead-on-select="vm.addPrivcat($item, $model, $label)"
                       uib-typeahead="privcat as privcat.text for privcat in vm.getPrivcats($viewValue)"
                       typeahead-loading="loadingNames"
                       typeahead-no-results="noResults">
                <span class="input-group-btn">
                    <button type="submit" ng-class="{'btn-warning': noResults, 'btn-info': !noResults}"
                            class="btn" tabindex="-1">
                        <i class="fa fa-search"></i>
                    </button>
                </span>
            </div>
            <div><i ng-show="loadingNames" class="fa fa-refresh"></i></div>
            <div ng-show="noResults">
                <i class="fa fa-warning"></i> Keine passenden Privatleistungen gefunden
                <!--<span class="btn btn-success" ng-click="vm.addPrivcat()"
                      ng-hide="vm.error">Neue Privatleistung eingeben</span>-->
                <!--<span ng-click="vm.addPrivcatEntry()" ng-show="vm.error"><i class="fa fa-warning text-danger"></i> Privatleistung konnte nicht angelegt werden!</span>-->
            </div>
        </div>
    </div>

    <div class=" row">
        <div class="col-xs-12">
            <label for="grpname">Enthaltene Leistungen</label>
            <div class="alert alert-info" ng-hide="vm.privcatgroup.items.length > 0">
                <i class="fa fa-info-circle"></i> Diese Gruppe enthält derzeit keine Leistungen!
            </div>
            <ul>
                <li ng-repeat="entry in vm.privcatgroup.items" style="padding: 3px">
                    <span class="pull-left">{{entry.shortcut}} - {{entry.name}}</span>
                    <span class="pull-right">
                        <span class="btn btn-danger btn-xs" uib-tooltip="Leistung aus Gruppe entfernen" ng-click="vm.removeEntry($index)">
                            <i class="fa fa-remove"></i>
                        </span>
                    </span>
                </li>
            </ul>
        </div>
    </div>


    <div class=" row">
        <div class="col-xs-12">
            <div class="form-group">
                <button class="btn btn-success" type="button" tabindex="9" ng-click="vm.save()">Speichern</button>
                <button class="btn btn-danger" type="button" tabindex="10" ng-click="vm.cancel()">Abbrechen</button>
            </div>
        </div>
    </div>
</form>
